import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import { useTranslation } from 'react-i18next';
import { Flex } from 'nallian-shared-ui/lib/components';
import { useNavigate } from 'react-router-dom';
import updateCommunityRoleService from '../../services/communityRoles/updateCommunityRoleService';
import communityRoleService from '../../services/communityRoles/communityRoleService';
import CommunityRoleForm from './CommunityRoleForm';

const EditCommunityRole = ({
  open,
  dispatchUpdateCommunityRolePut,
  updateCommunityRoleFetch,
  dispatchCommunityRoleGet,
  communityRoleFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id, actionId } = useParams();

  const handleSubmit = useCallback(
    body =>
      dispatchUpdateCommunityRolePut(
        id,
        body.tag,
        pickBy(pick(body, ['alias', 'version']), v => v !== null && v !== undefined && v !== ''),
        () => navigate(`/communities/edit/${id}`),
        t
      ),
    [id, dispatchUpdateCommunityRolePut, t, navigate]
  );

  useEffect(() => {
    if (open && id && actionId) {
      dispatchCommunityRoleGet(id, actionId, t);
    }
  }, [id, actionId, open, t, dispatchCommunityRoleGet]);

  if (!open) return null;

  return (
    <CommunityRoleForm
      header={
        <Flex>
          {t('editCommunityRole')}&nbsp;-&nbsp;
          {communityRoleFetch.value?.name}
        </Flex>
      }
      onSubmit={handleSubmit}
      submitProcessing={updateCommunityRoleFetch.pending}
      returnRoute={`/communities/edit/${id}`}
      cancelRoute={`/communities/edit/${id}`}
      dataLoading={communityRoleFetch.pending}
      data={!communityRoleFetch.pending && communityRoleFetch.value}
      showRemoveButton
      editMode
    />
  );
};

EditCommunityRole.propTypes = {
  dispatchUpdateCommunityRolePut: PropTypes.func.isRequired,
  updateCommunityRoleFetch: PropTypes.object.isRequired,
  dispatchCommunityRoleGet: PropTypes.func.isRequired,
  communityRoleFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

EditCommunityRole.defaultProps = { open: false };

export default compose(communityRoleService, updateCommunityRoleService)(EditCommunityRole);
